import AssignWorkflowsListLayer from "../components/AssignWorkflowsLayer";
import Breadcrumb from "../components/Breadcrumb";

const AssignWorkflowsListPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title=" Assign Workflows" />

      <AssignWorkflowsListLayer />
    </>
  );
};

export default AssignWorkflowsListPage;
